import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { LegalDocument } from '../../models/legal-document.model';
import { LegalDocumentsService } from '../../services/legal-documents.service';

@Component({
  selector: 'app-terms-and-conditions',
  templateUrl: './terms-and-conditions.component.html',
  styleUrl: './terms-and-conditions.component.css'
})
export class TermsAndConditionsComponent {
  formatUpdatedAt(value: unknown): Date | null {
    const candidate = value as { toDate?: () => Date } | Date | null | undefined;
    if (candidate instanceof Date) {
      return candidate;
    }

    if (candidate && typeof candidate === "object" && typeof candidate.toDate === "function") {
      return candidate.toDate();
    }

    return null;
  }

  readonly document$: Observable<LegalDocument> = this.legalDocumentsService.getLegalDocument('terms-and-conditions');

  constructor(private readonly legalDocumentsService: LegalDocumentsService) {}
}
